import OBBTvComponent from "../../components/OBBTvComponent";
import HomeProgramlarComponent from "./components/HomeProgramlarComponent";
import React from "react";

const Home = () => {
    return(
        <>
            <div className="main-slider-program">
                <div className={"bg-color"}></div>
                <OBBTvComponent/>
            </div>

            <div className="main-programs container">
                <HomeProgramlarComponent/>
            </div>
        </>
    )
}

export default Home;